import type { CustomWidgetDescription } from 'components/management/customDashboard/CustomWidgetDescription.types.ts';
import { GridView } from '@mui/icons-material';
import DailyPnlGrid from './DailyPnlGrid.tsx';
import { useWidgetState } from '../../../management/customDashboard/CustomWidgetContext.tsx';
import { getDefaultRange, getRangeByLabel } from 'components/predefinedDateRanges.ts';
const createPresetKey = (id: string) => `customWidget/dailyPnl/${id}`;
// import { DailyPnlWidgetSettings, type DailyPnlWidgetState } from './DailyPnlWidgetSettings.tsx';
import {
  TradingActivityWidgetSettings,
  type TradingActivityWidgetState,
} from 'components/bookkeeping/tradingActivity/TradingActivityWidgetSettings.tsx';
export const dailyPnlWidget: CustomWidgetDescription = {
  name: 'Daily P&L',
  type: 'dailyPnl',
  description: 'Analyze daily returns by sub-account',
  icon: () => <GridView />,
  viewComponent: ({ id }) => {
    const initialState = useWidgetState<TradingActivityWidgetState>(id);
    const range = getRangeByLabel(initialState.predefinedDateRange) ?? getDefaultRange();
    const dateRange = range.value();
    return <DailyPnlGrid {...initialState} presetSettingsKey={createPresetKey(id)} dateRange={dateRange} fullHeight />;
  },
  settingsComponent: (props) => <TradingActivityWidgetSettings {...props} presetKey={createPresetKey(props.id)} />,
  initialState: {
    title: 'Daily P&L',
    predefinedDateRange: '7D',
  } satisfies TradingActivityWidgetState,
  initialH: 4,
  initialW: 3,
};
